export const KEY_POINTS = [
  {
    id: 1,
    title: 'Inscription du filleul',
    description: 'Partagez-nous les coordonnées de votre filleul.'
  },
  {
    id: 2,
    title: 'Accompagnement Hosman',
    description: "Nous l'accompagnerons dans son projet de vente."
  },
  {
    id: 3,
    title: 'Acte authentique',
    description: "En cas de signature d'un acte de vente, vous touchez la prime correspondante au prix de vente"
  }
];
